// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Let_syntax from "../../../../packages/core/lib/Let_syntax.js";
import * as Buhta_documentapis__Buhta_document_v1alpha1_contractor_service from "../../../../proto/documentapis/gen/buhta_document_v1alpha1_contractor_service.js";
import * as Curry from "melange.js/curry.js";

const Contractor = {};

const ContractorBankAccount = {};

function toCreateRequest(form) {
  return Curry._2(Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.CreateContractorRequest.make, form, undefined);
}

function toUpdateRequest(id, form) {
  return Curry._3(Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.UpdateContractorRequest.make, id, form, undefined);
}

function toCreateRequest$1(contractor, form) {
  return Curry._3(Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.CreateContractorBankAccountRequest.make, contractor, form, undefined);
}

function toUpdateRequest$1(contractor, id, form) {
  return Curry._4(Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.UpdateContractorBankAccountRequest.make, contractor, id, form, undefined);
}

function view(tenant, expandOpt, id, param) {
  const request = Curry._3(Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.GetContractorRequest.make, id, undefined, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.contractor);
              }), Buhta_core__Grpc.makeRpc(request, Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.getContractor, undefined, tenant, undefined, Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.GetContractor.name, undefined, undefined));
}

function grid(tenant, params, param) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return response.contractors;
              }), Buhta_core__Grpc.makeRpc(Curry._2(Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ListContractorsRequest.make, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined), Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.listContractors, undefined, tenant, undefined, Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.ListContractors.name, undefined, undefined));
}

function create(tenant, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.contractor);
              }), Buhta_core__Grpc.makeRpc(toCreateRequest(form), Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.createContractor, undefined, tenant, undefined, Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.CreateContractor.name, undefined, undefined));
}

function update(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.contractor);
              }), Buhta_core__Grpc.makeRpc(toUpdateRequest(id, form), Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.updateContractor, undefined, tenant, undefined, Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.UpdateContractor.name, undefined, undefined));
}

function $$delete(tenant, id, param) {
  return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_core__Grpc.makeRpc(Curry._2(Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.DeleteContractorRequest.make, id, undefined), Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.deleteContractor, undefined, tenant, undefined, Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.DeleteContractor.name, undefined, undefined), (function (result) {
                if (result.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: undefined
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: result._0
                        };
                }
              }));
}

const ContractorService = {
  view: view,
  grid: grid,
  create: create,
  update: update,
  $$delete: $$delete
};

function create$1(tenant, contractor, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.bank_account);
              }), Buhta_core__Grpc.makeRpc(toCreateRequest$1(contractor, form), Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.createContractorBankAccount, undefined, tenant, undefined, Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.CreateContractorBankAccount.name, undefined, undefined));
}

function update$1(tenant, contractor, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.bank_account);
              }), Buhta_core__Grpc.makeRpc(toUpdateRequest$1(contractor, id, form), Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.updateContractorBankAccount, undefined, tenant, undefined, Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.UpdateContractorBankAccount.name, undefined, undefined));
}

function $$delete$1(tenant, contractor, id, param) {
  return Curry._2(Buhta_core__Let_syntax.Bindings.let$plus, Buhta_core__Grpc.makeRpc(Curry._3(Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.DeleteContractorBankAccountRequest.make, contractor, id, undefined), Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.deleteContractorBankAccount, undefined, tenant, undefined, Buhta_documentapis__Buhta_document_v1alpha1_contractor_service.Buhta.$$Document.V1alpha1.ContractorService.DeleteContractorBankAccount.name, undefined, undefined), (function (result) {
                if (result.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: undefined
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: result._0
                        };
                }
              }));
}

const ContractorBankAccountService = {
  create: create$1,
  update: update$1,
  $$delete: $$delete$1
};

const ContractorCreateForm = {};

const ContractorUpdateForm = {};

const ContractorBankAccountCreateForm = {};

const ContractorBankAccountUpdateForm = {};

export {
  Contractor ,
  ContractorBankAccount ,
  ContractorCreateForm ,
  ContractorUpdateForm ,
  ContractorBankAccountCreateForm ,
  ContractorBankAccountUpdateForm ,
  ContractorService ,
  ContractorBankAccountService ,
}
/* Buhta_core__Grpc Not a pure module */
